/**
 * @changelog
 *
 * 2026-09-08 (0.1.0) (jhoward)
 *   - Add src\helpers\getPropertyName.ts as the guest-facing property name lookup, layered over the framework's
 *     propertyCodeToName so only the names that differ for a guest are stated here.
 */

import { propertyCodeToName } from '@framework/defs/property';

/**
 * Where a property is called something different in front of a guest than it is in the framework's map. The framework
 * calls the Wendover group 'Wendover Consolidated', which is how it is referred to internally; everywhere a guest can
 * see it - the 2C header and footer, the win/loss statement, the transactional mail - it is 'Resorts at Wendover'.
 *
 * 2A and 2B are deliberately absent: 'Peppermill Reno' and 'Western Village' are already the guest-facing names.
 */
const guestFacingPropertyNames: { [key: string]: string } = {
  '2C': 'Resorts at Wendover',
  '07': 'Resorts at Wendover',
  WC: 'Resorts at Wendover',
};

export default function getPropertyName(propertyCode: string | null | undefined, fallback: string = '—'): string {
  if (!propertyCode) {
    return fallback;
  }

  return guestFacingPropertyNames[propertyCode] || propertyCodeToName[propertyCode] || propertyCode;
}
